export default __webpack_public_path__ + "assets/images/096de9a5b57a257b504a539eb3a3bce7.jpg";